/* eslint-disable react-refresh/only-export-components */
import { createFileRoute } from '@tanstack/react-router'
import { BuyerEditPage } from '@/features/operations'
import { requireRole } from '@/lib/auth-guards'

export const Route = createFileRoute('/_authenticated/targets/$id')({
  component: BuyerEditRoutePage,
  beforeLoad: requireRole(['admin']),
})

function BuyerEditRoutePage() {
  const { id } = Route.useParams()
  return <BuyerEditPage key={id} buyerId={id} />
}
